import { persistNSync } from "persist-and-sync";
import { cacheBucket } from "PFCore/base/storage/storage";
import { create } from "zustand";
import { useShallow } from "zustand/shallow";

import { AuthStoreType } from "./auth_store_types";

const useAuthStoreBase = create<AuthStoreType>()(
  persistNSync(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      actions: {
        getAccessToken: () => get().accessToken,
        getRefreshToken: () => get().refreshToken,
        setTokens: (accessToken: string, refreshToken?: string) => set({ accessToken, refreshToken }),
        clearTokens: () => set({ accessToken: null, refreshToken: null })
      }
    }),
    { name: `${cacheBucket}authState`, exclude: ["actions"] }
  )
);

export const useAuthStore = <U>(selector: (state: AuthStoreType) => U) =>
  useAuthStoreBase(useShallow(selector));

export const useAuthStoreActions = () => useAuthStore((state) => state.actions);
